<template>
  <div>
    <v-card v-if="!$vuetify.breakpoint.smAndDown">
      <v-system-bar>Archivierte Rechnungen</v-system-bar>
      <InvoiceTable :items="itemsFiltered" page="InvoiceArchived" />
    </v-card>
    <template v-else
      ><InvoiceCards :items="itemsFiltered" page="InvoiceArchived" />
    </template>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import InvoiceCards from "./Components/InvoiceCards.vue";
import InvoiceTable from "./Components/InvoiceTable.vue";

export default defineComponent({
  components: { InvoiceCards, InvoiceTable },
  props: {
    search: { type: String },
  },
  data() {
    return {
      items: [],
    };
  },
  computed: {
    itemsFiltered() {
      return this.items.filter(
        (item) =>
          item.event.toLowerCase().includes(this.search.toLowerCase()) ||
          item.description.toLowerCase().includes(this.search.toLowerCase())
      );
    },
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.items = await this.apiList({
        resource: "finance/invoice",
        query: "status=entered",
      });
      this.items = this.items.concat(
        await this.apiList({
          resource: "finance/invoice",
          query: "status=archived",
        })
      );
      this.loading = false;
    },
  },
  async created() {
    this.fetchData();
  },
});
</script>
